/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2023 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: external-metadata-resource-factory
 */
'use strict';
angular
    .module('prism-ui.components.data')
    .factory('AggregationResourceFactory',
        ($resource: JS5Function, EndPointService: JS5Object) => {

            return $resource(EndPointService.aggregationEndPoint + '/setup/:id', {id: '@id'}, {
                save: {
                    method: 'POST',
                    url: EndPointService.aggregationEndPoint + '/setup',
                    isArray: false
                },
                update: {
                    method: 'PUT',
                    url: EndPointService.aggregationEndPoint + '/setup/:id',
                    isArray: false
                },
                run: {
                    method: 'POST',
                    url: EndPointService.aggregationEndPoint + '/setup/:id',
                    isArray: true,
                    params: {
                        filename: '@filename',
                    },
                    headers: {
                        'Content-Type': 'application/xml',
                    },
                },
                getTasks: {
                    method: 'GET',
                    url: EndPointService.aggregationEndPoint + '/tasks',
                    isArray: true,
                    params: {
                        contentId: '@contentId',
                        packageId: '@packageId',
                        externalSystem: '@externalSystem',
                        externalId: '@externalId',
                    },
                },

            });
});
